<!-- eslint-disable -->
<template lang="pug">
    .divider(
        :style="{margin: dividerMarginValue}"
        :class="{'divider_not-show-last-child': notShowLastChild}"
    )
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            margin: [Number, String],
            notShowLastChild: Boolean,
        },
        computed: {
            dividerMarginValue () {
                return this.margin !== undefined ? this.margin : '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .divider {
        width: 100%;
        border-bottom: 1px solid $hsl-color-gray-94;
        margin: 30px auto;
    }

    .divider_not-show-last-child:last-child {
        display: none;
    }
</style>